export default __webpack_public_path__ + "static/media/amendment-icon.035f0c9d.svg";